// extracted by mini-css-extract-plugin
export default {"actuality":"styles_actuality__55295","blue":"styles_blue__YxlF7","white":"styles_white__aHube"};